import Nullstack from 'nullstack';
export default function IconThermometer({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-thermometer",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M19 5a2.828 2.828 0 0 1 0 4l-8 8h-4v-4l8 -8a2.828 2.828 0 0 1 4 0z"
  }), "   ", Nullstack.element("path", {
    d: "M16 7l-1.5 -1.5"
  }), "   ", Nullstack.element("path", {
    d: "M13 10l-1.5 -1.5"
  }), "   ", Nullstack.element("path", {
    d: "M10 13l-1.5 -1.5"
  }), "   ", Nullstack.element("path", {
    d: "M7 17l-3 3"
  }), " ");
}